import { Formik } from 'formik'
import Translation from '../../Translation/cont/Translation'
import PreviewMovieFormFields from './PreviewMovieFormFields'
import buildPreviewMoviePayload from '../../../functions/buildPreviewMoviePayload'

const DialogEditPreviewMovie = ({ item, startingDate, onSave, onClose, cinemas, cliCinemasIdList }) => (
    <div className="preview-movie-dialog-overlay" onClick={onClose}>
        <div className="preview-movie-dialog" onClick={e => e.stopPropagation()}>
            <div className="preview-movie-dialog-head">
                <span className="preview-movie-dialog-title"><Translation id="preview_movies_page_title_edit" /></span>
                <button className="preview-movie-dialog-close text-small-regular" type="button" onClick={onClose}>✕</button>
            </div>
            <Formik initialValues={{
                title: item.title || '',
                expectedStartDate: startingDate || '',
                startDateDescription: item.startDateDescription || '',
                cinemasFilter: item.visibleIn && item.visibleIn.length > 0 ? item.visibleIn : cliCinemasIdList,
            }}>
                {({ values, setFieldValue }) => {
                    const isValid = values.title.trim().length > 0

                    return (
                        <>
                            <div className="preview-movie-dialog-body">
                                <PreviewMovieFormFields
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    cinemas={cinemas}
                                    cliCinemasIdList={cliCinemasIdList}
                                />
                            </div>
                            <div className="preview-movie-dialog-footer">
                                <button className="button" onClick={() => onSave(buildPreviewMoviePayload(values, cliCinemasIdList))} disabled={!isValid}>
                                    <Translation id="save_button" />
                                </button>
                                <button className="button button--cancel" type="button" onClick={onClose}>
                                    <Translation id="cancel_button" />
                                </button>
                            </div>
                        </>
                    )
                }}
            </Formik>
        </div>
    </div>
)

export default DialogEditPreviewMovie
